//@flow
import React from 'react'
import swissData from '../../data/schweiz.json'
import swissDataFR from '../../data/schweizFR.json'
import './styles.scss'

function numberWithApostroph(x) {
  let num = x.toString()
  if(num.length > 4) {
    num = x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "'")
  }
  return num;
}

function Column({ city, i, lang }) {
  return (
    <div className={'column'} key={'city-'+i}>
      <h3>{city.city}</h3>
      <img src={require('../../images/'+city.image+'.png')} alt={city.image}/>
      <div className='pop'>
        {numberWithApostroph(city.pop)} <span className='unit'>{lang === 'fr' ? 'Personnes' : 'Personen'} / km<sup>2</sup></span>
      </div>
      <div className="desc">
        {city.text}
      </div>
    </div>
  )
}


export class Grid extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {
    }
    this.updateSizes = this.updateSizes.bind(this)
  }

  updateSizes() {
    this.setState({
      isMobile: window.innerWidth < 711
    })
  }
  
  componentDidMount() {
    window.addEventListener('resize', this.updateSizes)
    this.updateSizes()
  }

  render() {
    this.chData = this.props.tenant.lang === 'fr' ? swissDataFR : swissData
    return <div className='grid'>
       <h2>{this.props.tenant.lang === 'fr' ? this.props.titleFR : this.props.titleDE}</h2>
      <div className='two-column'>
        {this.chData && this.chData.map((city, i) => {
          return (
            <Column city={city} i={i} lang={this.props.tenant.lang} />
            )})
        }
      </div>
    </div>
  }
}



             